import { LoadingButton } from "@mui/lab";
import { Box, Tooltip, TooltipProps, styled } from "@mui/material";

export const ButtonPlaceholder = styled(Box)(({theme}) => {
    return {
        width: theme.spacing(5.25),
        height: theme.spacing(5.25),
        minWidth: theme.spacing(5.25),
        marginLeft: theme.spacing(2),
        visibility: 'hidden'
    }
})

export const CounterButton = styled(LoadingButton)(({theme}) => {
    return {
        width: theme.spacing(5.25),
        height: theme.spacing(5.25),
        minWidth: theme.spacing(5.25),
        position: 'relative',
        padding: 0,

        '& svg': {
            fontSize: `2rem`
        }
    }
})

export const CounterButtonBox = styled(Box)(({theme}) => {
    return {
        width: theme.spacing(5.25),
        height: theme.spacing(5.25),
        minWidth: theme.spacing(5.25),
        marginLeft: theme.spacing(2),
        position: 'relative'
    }
})

export const CounterChip = styled(Box, {
    shouldForwardProp: prop => prop !== 'position' && prop !== 'color'
})<{ 
    position?: 'top' | 'bottom';
    color?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'error';
}>(({ theme, color, position }) => {

    const top = position === 'bottom' ?
        undefined :
        theme.spacing(0.5);

    const bottom = position === 'bottom' ?
        theme.spacing(0.5) :
        undefined;

    const right = theme.spacing(0.5);

    return {
        position: 'absolute',
        top: top,
        right: right,
        bottom: bottom,
        minHeight: theme.spacing(1.75),
        minWidth: theme.spacing(1.75),
        fontSize: '0.6rem',
        lineHeight: 1,
        padding: theme.spacing(0.25, 0.4),
        background: theme.palette[color ?? 'secondary'].main,
        borderRadius: theme.shape.borderRadius,
        color: theme.palette.secondary.contrastText,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
});

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    marginTop: '12px !important'
}));